import React, { useState } from 'react';

import {
  Text,
  Card,
  useResponsiveParams,
  CircleButton,
  Modal,
} from 'quanta-ui';
import { useHistory } from 'react-router-dom';
import ImportQuoteModal from './import-quote-modal';
// import { updateMotorQuote } from '../_graphql/state';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
import { GET_PCV_POLICY_VAR_DETAILS } from '../queries';
// import { Error, Loading } from '../../../../../lib/layout';
import { Error,Loading} from 'quanta-flows/modules/layout';
import { useQuery } from '@apollo/client';

const BulbIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-8 w-8"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
    />
  </svg>
);

export default function CopyQuote({
  setMoveToPlans,
  quoteNumber,
  productCode,
  productName,
  lobCode,
  category,
}) {
  const history = useHistory();
  const [copyQuoteDisplay, setCopyQuoteDisplay] = useState(false);
  const [copyQuoteCardDisplay, setCopyQuoteCardDisplay] =
    useState(false);
  const screenType = useResponsiveParams({
    for_desktop: 'desktop',
    for_mobile: 'mobile',
    for_iPad: 'ipad',
  });
  const { loading, error, data } = useQuery(
    GET_PCV_POLICY_VAR_DETAILS,
  );
  const { motorQuote } = data;
  const CopyQuoteCard = () => (
    <Card className="h-full p-0 mb-4">
      <Text className="flex flex-col w-full h-full space-y-4">
        <Text className={'flex space-x-2 items-center'}>
          <Text severity={'info'}>
            <BulbIcon />
          </Text>
          <Text severity={'info'} type={'title'}>
            Do you know ?
          </Text>
        </Text>
        <Text>
          {quoteNumber
            ? 'You can copy this already saved quote to a new quote.'
            : 'You can save time by copying from an existing quote.'}
        </Text>
        <Text
          className={'w-full h-full mt-4 quanta_link p-2 text-center'}
          onClick={() => {
            if (quoteNumber) {
              updateMotorQuote({
                get_covers : true,
                quotationNo: '',
                isQuoteSaving: false,
                quotationStatus: '',
                quoteCreationDate: '',
                proposalNumber: '',
                currentTab: 'covers',
                captureMode: 'create',
                isCopyFromOutside: true,
              });
              if(productCode === '3183' || productCode ==='3184' ){
               history?.push(
                  `/quote/Motor/${lobCode}/PCV/${productCode}`,
                );
              }else{
              history?.push(
                `/quote/Motor/${lobCode}/${productName}/${productCode}`,
              );
              }
              setTimeout(function () {
                window?.scrollTo({ top: 0, behavior: 'smooth' });
              }, 200);
              document.body.classList.remove('overflow-y-hidden');
            } else {
              setCopyQuoteDisplay(true);
              setCopyQuoteCardDisplay(false);
            }
          }}
        >
          {quoteNumber ? 'Copy this Quote' : 'Click here to try'}
        </Text>
      </Text>
    </Card>
  );

  if (loading) {
    return (
      <Card className={'h-full p-0 mb-4'}>
        <Loading />
      </Card>
    );
  }
  if (error) {
    return (
      <Card className={'h-full p-0 mb-4'}>
        <Error error={error} />
      </Card>
    );
  }

  return (
    quoteNumber
      ? true
      : motorQuote?.currentTab?.toString()?.toLowerCase() ===
          'vehicle' && !motorQuote?.quotationNo
  ) ? (
    screenType?.toString()?.toLowerCase() === 'desktop' ? (
      <>
        <CopyQuoteCard />
        <ImportQuoteModal
          copyQuoteDisplay={copyQuoteDisplay}
          setCopyQuoteDisplay={setCopyQuoteDisplay}
          setMoveToPlans={setMoveToPlans}
          category={category}
          productName={productName}
        />
      </>
    ) : (
      <>
        <Modal
          display={copyQuoteCardDisplay}
          severity={'action'}
          onClose={(_) => {
            setCopyQuoteCardDisplay(false);
          }}
          useFragment={true}
          fragmentSizeRequired={true}
          fragmentSize={'small'}
          className={'h-auto'}
        >
          <CopyQuoteCard />
        </Modal>
        <Text className="fixed bottom-32 right-4 z-40">
          <CircleButton
            size="medium"
            onClick={(e) => setCopyQuoteCardDisplay(true)}
          >
            <BulbIcon />
          </CircleButton>
        </Text>
        <ImportQuoteModal
          copyQuoteDisplay={copyQuoteDisplay}
          setCopyQuoteDisplay={setCopyQuoteDisplay}
          setMoveToPlans={setMoveToPlans}
        />
      </>
    )
  ) : null;
}
